import { render, staticRenderFns } from "./RemoteCursor.vue?vue&type=template&id=77208d93&scoped=true&"
import script from "./RemoteCursor.vue?vue&type=script&lang=js&"
export * from "./RemoteCursor.vue?vue&type=script&lang=js&"
import style0 from "./RemoteCursor.vue?vue&type=style&index=0&id=77208d93&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77208d93",
  null
  
)

export default component.exports